// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__25yXx","header":"ClearentDisclaimer_header__3LoGi","inner":"ClearentDisclaimer_inner__ICPiT"};